import React from 'react';
import { useNavigate } from 'react-router-dom';
import Stundenkontingente from '../../assets/pictures/Excel Custom.svg';
import Excel from '../../assets/pictures/Excel Import Emma.svg';
import P2 from '../../assets/pictures/Spezial Download.svg';

const cards = [
    {
        name: 'Custom Export',
        path: '/stundenkontingente',
        image: Stundenkontingente,
        description: 'Hier können Sie einen individuellen Stundenexport konfigurieren und als Excel Datei herunterladen.',
    },
    {
        name: 'Import am Monatsende',
        path: '/stundenkontingente/import',
        image: Excel,
        description: 'Hier können Sie am Monatsende einen Gustaff-Export importieren. Dadurch wird das Risikomanagement finalisiert und die Stundenkontingente werden aktualisiert.',
    },
    {
        name: 'Spezialauswertungen',
        path: '/stundenkontingente/import/special',
        image: P2,
        description: 'Hier können Sie einen Gustaff-Export importieren, ohne ihn im System anzulegen. Der Import wird ausschließlich für die Auswertung der Stundenkontingente verwendet – so wie in der P2-Phase.',
    },
];

export default function StundenkontingenteSelection() {
    const navigate = useNavigate();

    return (
        <main className="w-full h-full px-4 py-4">
            <div className="flex w-full h-full gap-4">
                {cards.map(card => (
                    <div
                        key={card.name}
                        onClick={() => navigate(card.path)}
                        className="group flex-1 h-full relative cursor-pointer overflow-hidden rounded-2xl shadow-lg transition-all"
                    >
                        {/* Background image */}
                        <div
                            className="absolute inset-0 z-0 bg-cover bg-center transition-all duration-500 group-hover:blur-md group-hover:grayscale group-hover:scale-105"
                            style={{ backgroundImage: `url("${card.image}")` }}
                        />
                        {/* Dark overlay */}
                        <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 pointer-events-none" />
                        {/* Text */}
                        <div className="absolute inset-0 z-20 flex flex-col items-center justify-start pt-40 text-center text-black px-4">
                            <h2 className="text-4xl font-bold drop-shadow">{card.name}</h2>
                            <p className="text-lg mt-4 hidden group-hover:block transition-all duration-300">
                                {card.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </main>
    );
}
